"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageContextProvider = exports.useLanguage = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var LanguageContext = /*#__PURE__*/_react["default"].createContext();
var LanguageContextProvider = function LanguageContextProvider(_ref) {
  var children = _ref.children,
    language = _ref.language;
  var changeLanguage = function changeLanguage(lang) {
    var domains = global.__appConfig__.domainLanguages;
    var domain = Object.keys(domains).find(function (key) {
      return domains[key] === lang;
    });
    window.location.href = "http://".concat(domain);
  };
  return __jsx(LanguageContext.Provider, {
    value: {
      language: language,
      changeLanguage: changeLanguage
    }
  }, children);
};
exports.LanguageContextProvider = LanguageContextProvider;
var useLanguage = function useLanguage() {
  return (0, _react.useContext)(LanguageContext);
};
exports.useLanguage = useLanguage;